module.exports = __webpack_public_path__ + "static/media/logo-unicafes.4955581e.png";